import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

export const FltChkItem = styled.li`
  padding: 8px 8px 8px 0;

  .checkbox {
    width: 100%;

    .label {
      font-size: 15px;
      margin-right: 0;
      word-break: keep-all;
      overflow-wrap: break-word;
      white-space: normal;
      overflow: hidden;
    }

    .txt {
      margin-right: 4px;
    }

    .cnt {
      font-size: 14px;
      font-weight: 500;
      color: #bbb;
    }
  }

  @media ${({ theme }) => theme.media.smMax} {
    padding: ${mixin.pxToVw('8 8 8 0')};

    .checkbox {
      .label {
        font-size: ${mixin.pxToVw('15')};
      }

      .txt {
        margin-right: ${mixin.pxToVw('4')};
      }

      .cnt {
        font-size: ${mixin.pxToVw('14')};
      }
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    padding: 9px 10px 9px 0;

    .checkbox {
      .label {
        font-size: 16px;
      }

      .txt {
        margin-right: 6px;
      }

      .cnt {
        font-size: 15px;
      }
    }
  }
`;
